// GENERATED by scripts/act-catalog.mjs from the place sources: do not edit by hand.
// Every place's acts (id, label, rarity), three-free, for the release curve (src/domain/release.ts).
import type { CatalogAct } from '../../domain/release'

export const ACT_CATALOG: Record<string, readonly CatalogAct[]> = {
  "bigcity": [
    { id: "seven", label: "Shinkansen 7-minute clean", rarity: 'common' },
    { id: "taxi", label: "Taxi auto-door", rarity: 'common' },
    { id: "yakitori", label: "Yokochō smoke", rarity: 'common' },
    { id: "koji", label: "Bowing builders", rarity: 'common' },
    { id: "rooftop", label: "Beer-garden rooftop", rarity: 'common' },
    { id: "street", label: "Guerrilla downpour", rarity: 'common' },
    { id: "inoshishi", label: "Wild boar in town", rarity: 'rare' },
    { id: "opening", label: "Store opening bow", rarity: 'common' },
    { id: "ekiben", label: "Ekiben seller", rarity: 'common' },
    { id: "harbourlights", label: "Harbour fireworks finale", rarity: 'legendary' },
  ],
  "castletown": [
    { id: "wanman", label: "Two-car local train", rarity: 'common' },
    { id: "garapon", label: "Shopping-street lottery", rarity: 'common' },
    { id: "yakyu", label: "School baseball", rarity: 'common' },
    { id: "sento", label: "Bathhouse coffee milk", rarity: 'common' },
    { id: "taiso", label: "Radio calisthenics", rarity: 'common' },
    { id: "vendor", label: "Kakigōri stand", rarity: 'common' },
    { id: "sanshouo", label: "Giant salamander", rarity: 'rare' },
    { id: "bonodori", label: "Bon dance", rarity: 'common' },
    { id: "hatsumode", label: "New Year shrine visit", rarity: 'common' },
    { id: "yurukyara", label: "The town mascot", rarity: 'legendary' },
  ],
  "fuji": [
    { id: "ship", label: "Pirate ship", rarity: 'common' },
    { id: "egg", label: "Black eggs", rarity: 'common' },
    { id: "ropeway", label: "Ropeway steam bath", rarity: 'common' },
    { id: "kasa", label: "Fuji's hat cloud", rarity: 'common' },
    { id: "goraiko", label: "Summit sunrise", rarity: 'common' },
    { id: "ekiden", label: "Hakone Ekiden", rarity: 'common' },
    { id: "diamond", label: "Diamond Fuji", rarity: 'rare' },
    { id: "tozan", label: "Hakone Tozan switchback", rarity: 'common' },
    { id: "deer", label: "Sika deer and the hōtō pot", rarity: 'common' },
    { id: "stamp", label: "Fuji staff stamp", rarity: 'common' },
    { id: "serow", label: "Japanese serow", rarity: 'rare' },
    { id: "akafuji", label: "Aka-Fuji (red Fuji)", rarity: 'legendary' },
  ],
  "fukuoka": [
    { id: "yamakasa", label: "Yamakasa race", rarity: 'common' },
    { id: "kaedama", label: "Kaedama!", rarity: 'common' },
    { id: "mentaiko", label: "Spicy mentaiko", rarity: 'common' },
    { id: "ox", label: "Bronze ox", rarity: 'common' },
    { id: "fountain", label: "Dancing fountain", rarity: 'common' },
    { id: "tower", label: "Tower light show", rarity: 'common' },
    { id: "tobiume", label: "Tobiume, the flying plum", rarity: 'rare' },
    { id: "dontaku", label: "Hakata Dontaku", rarity: 'common' },
    { id: "cruise", label: "River cruise", rarity: 'common' },
    { id: "tonbi", label: "Black kite raid", rarity: 'common' },
    { id: "turtles", label: "Shinji pond turtles", rarity: 'rare' },
    { id: "hanabi", label: "Ōhori Park fireworks", rarity: 'legendary' },
  ],
  "hangang": [
    { id: "fountain", label: "Rainbow fountain", rarity: 'common' },
    { id: "ramyeon", label: "Ramyeon machine", rarity: 'common' },
    { id: "chimaek", label: "Chimaek delivery", rarity: 'common' },
    { id: "bike", label: "Ttareungi bike", rarity: 'common' },
    { id: "cable", label: "Namsan cable car", rarity: 'common' },
    { id: "busking", label: "Busking crew", rarity: 'common' },
    { id: "fishing", label: "Angler", rarity: 'common' },
    { id: "ferry", label: "Hangang Bus", rarity: 'common' },
    { id: "tent", label: "Shade tent", rarity: 'common' },
    { id: "nightmarket", label: "Night market", rarity: 'common' },
    { id: "sled", label: "Sledding hill", rarity: 'common' },
    { id: "bungeo", label: "Bungeoppang", rarity: 'common' },
    { id: "gorani", label: "Water deer", rarity: 'rare' },
    { id: "otter", label: "River otter", rarity: 'rare' },
    { id: "yong", label: "River dragon", rarity: 'legendary' },
  ],
  "kamakura": [
    { id: "daibutsu", label: "Inside the Great Buddha", rarity: 'common' },
    { id: "yabusame", label: "Yabusame archer", rarity: 'common' },
    { id: "tobi", label: "Black kite thief", rarity: 'common' },
    { id: "enoden", label: "Enoden crossing", rarity: 'common' },
    { id: "surf", label: "Yuigahama surfer", rarity: 'common' },
    { id: "snail", label: "Hydrangea snail", rarity: 'common' },
    { id: "umigame", label: "Sea turtle", rarity: 'rare' },
    { id: "shirasu", label: "Shirasu bowl", rarity: 'common' },
    { id: "steps", label: "Hachimangū steps", rarity: 'common' },
    { id: "ferry", label: "Enoshima ferry", rarity: 'common' },
    { id: "bonbori", label: "Bonbori lanterns", rarity: 'rare' },
    { id: "nobi", label: "The Great Buddha stretches", rarity: 'legendary' },
  ],
  "kyoto": [
    { id: "maiko", label: "Maiko stroll", rarity: 'common' },
    { id: "torii", label: "Torii tunnel run", rarity: 'common' },
    { id: "koi", label: "Koi leap", rarity: 'common' },
    { id: "rickshaw", label: "Rickshaw dash", rarity: 'common' },
    { id: "bell", label: "Temple bell", rarity: 'common' },
    { id: "leaves", label: "Maple leaf pile", rarity: 'common' },
    { id: "kitsune", label: "White fox", rarity: 'rare' },
    { id: "daimonji", label: "Daimonji bonfire", rarity: 'common' },
    { id: "tea", label: "Tea ceremony", rarity: 'common' },
    { id: "yamaboko", label: "Gion Matsuri float", rarity: 'common' },
    { id: "neko", label: "Philosopher’s cat", rarity: 'rare' },
    { id: "kyubi", label: "Nine-tailed fox", rarity: 'legendary' },
  ],
  "miyajima": [
    { id: "tide", label: "Low-tide torii walk", rarity: 'common' },
    { id: "shamoji", label: "Giant rice scoop", rarity: 'common' },
    { id: "oyster", label: "Oyster grill", rarity: 'common' },
    { id: "momiji", label: "Maple cake machine", rarity: 'common' },
    { id: "ropeway", label: "Misen ropeway", rarity: 'common' },
    { id: "ferry", label: "Ferry horn", rarity: 'common' },
    { id: "tai", label: "Lucky sea bream", rarity: 'rare' },
    { id: "anago", label: "Anago-meshi lunch", rarity: 'common' },
    { id: "kite", label: "Kite raid", rarity: 'common' },
    { id: "fireworks", label: "Fireworks over the torii", rarity: 'common' },
    { id: "deermap", label: "Deer with the map", rarity: 'rare' },
    { id: "kangensai", label: "Kangensai boat festival", rarity: 'legendary' },
  ],
  "nara": [
    { id: "bow", label: "Deer bow", rarity: 'common' },
    { id: "senbei", label: "Shika senbei", rarity: 'common' },
    { id: "mochi", label: "Mochi pounding", rarity: 'common' },
    { id: "pillar", label: "Daibutsu pillar", rarity: 'common' },
    { id: "smoke", label: "Smoke for smarts", rarity: 'common' },
    { id: "lanterns", label: "Kasuga lanterns", rarity: 'common' },
    { id: "shinroku", label: "Sacred white deer", rarity: 'rare' },
    { id: "tsunokiri", label: "Antler cutting", rarity: 'common' },
    { id: "rickshaw", label: "Rickshaw stand-off", rarity: 'common' },
    { id: "wakakusa", label: "Wakakusa hill fire", rarity: 'common' },
    { id: "fawns", label: "Fawn parade", rarity: 'rare' },
    { id: "daibutsu", label: "The Great Buddha wakes", rarity: 'legendary' },
  ],
  "niseko": [
    { id: "kicker", label: "Park kicker", rarity: 'common' },
    { id: "wipeout", label: "Wipeout", rarity: 'common' },
    { id: "blackRun", label: "Black run", rarity: 'common' },
    { id: "treePop", label: "Tree pop", rarity: 'common' },
    { id: "yeti", label: "Yeti", rarity: 'rare' },
    { id: "chairDrop", label: "Chairlift drop", rarity: 'common' },
    { id: "skiSchool", label: "Ski school", rarity: 'common' },
    { id: "onsen", label: "Onsen surprise", rarity: 'common' },
    { id: "rail", label: "Rail grind", rarity: 'common' },
    { id: "snowcat", label: "Snowcat", rarity: 'common' },
    { id: "patrol", label: "Ski patrol", rarity: 'common' },
    { id: "fox", label: "Ezo red fox", rarity: 'rare' },
    { id: "torches", label: "Torchlight descent", rarity: 'common' },
    { id: "yetiLift", label: "Yeti on the chairlift", rarity: 'legendary' },
  ],
  "okinawa": [
    { id: "eisa", label: "Eisa drummers", rarity: 'common' },
    { id: "shisa", label: "Shisa wake up", rarity: 'common' },
    { id: "tsunahiki", label: "Giant tug-of-war", rarity: 'common' },
    { id: "goya", label: "Gōyā tasting", rarity: 'common' },
    { id: "sanshin", label: "Sanshin song", rarity: 'common' },
    { id: "turtle", label: "Sea turtle", rarity: 'common' },
    { id: "jinbe", label: "Whale shark", rarity: 'rare' },
    { id: "frond", label: "Typhoon gust", rarity: 'common' },
    { id: "yui", label: "Yui Rail", rarity: 'common' },
    { id: "andagi", label: "Sata andāgī", rarity: 'common' },
    { id: "kiji", label: "Kijimunā", rarity: 'rare' },
    { id: "ryu", label: "Shuri dragon pillars", rarity: 'legendary' },
  ],
  "osaka": [
    { id: "takoyaki", label: "Takoyaki flip", rarity: 'common' },
    { id: "crab", label: "Giant crab sign", rarity: 'common' },
    { id: "manzai", label: "Manzai on the bridge", rarity: 'common' },
    { id: "pose", label: "Running-man pose", rarity: 'common' },
    { id: "drum", label: "Drum doll", rarity: 'common' },
    { id: "cruise", label: "River cruise", rarity: 'common' },
    { id: "octopus", label: "Canal octopus", rarity: 'rare' },
    { id: "okonomi", label: "Okonomiyaki flip", rarity: 'common' },
    { id: "kushikatsu", label: "Kushikatsu: no double dip", rarity: 'common' },
    { id: "matsuri", label: "Tenjin Matsuri boat", rarity: 'common' },
    { id: "raincloud", label: "Tsūtenkaku weather light", rarity: 'common' },
    { id: "shachi", label: "Golden shachihoko", rarity: 'legendary' },
  ],
  "otaru": [
    { id: "boat", label: "Canal boat", rarity: 'common' },
    { id: "glass", label: "Glassblower", rarity: 'common' },
    { id: "steamClock", label: "Steam clock", rarity: 'common' },
    { id: "gull", label: "Gull raid", rarity: 'common' },
    { id: "lights", label: "Snow light path", rarity: 'common' },
    { id: "slip", label: "Slip on the ice", rarity: 'common' },
    { id: "seal", label: "Spotted seal", rarity: 'rare' },
    { id: "musicbox", label: "Giant music box", rarity: 'common' },
    { id: "rickshaw", label: "Rickshaw run", rarity: 'common' },
    { id: "snowdump", label: "Mama-san dump", rarity: 'common' },
    { id: "herring", label: "Herring rush", rarity: 'rare' },
    { id: "aurora", label: "Aurora over the canal", rarity: 'legendary' },
    { id: "musician", label: "Street musician", rarity: 'common' },
    { id: "flowers", label: "Flower boxes", rarity: 'common' },
    { id: "ushio", label: "Ushio Festival dance", rarity: 'common' },
  ],
  "sapporo": [
    { id: "ramen", label: "Ramen slurp", rarity: 'common' },
    { id: "streetcar", label: "Streetcar dash", rarity: 'common' },
    { id: "sculpture", label: "Snow sculpture", rarity: 'common' },
    { id: "iceSlide", label: "Ice slide", rarity: 'common' },
    { id: "crow", label: "Crow thief", rarity: 'common' },
    { id: "clockTower", label: "Clock tower", rarity: 'common' },
    { id: "plough", label: "Snow plough", rarity: 'rare' },
    { id: "snowball", label: "Snowball fight", rarity: 'common' },
    { id: "jingisukan", label: "Jingisukan grill", rarity: 'common' },
    { id: "lightshow", label: "TV Tower lights", rarity: 'common' },
    { id: "fox", label: "Ezo red fox", rarity: 'rare' },
    { id: "dragon", label: "The snow dragon wakes", rarity: 'legendary' },
    { id: "fountain", label: "Fountain show", rarity: 'common' },
    { id: "sprinkler", label: "Lawn sprinkler", rarity: 'common' },
    { id: "yosakoi", label: "YOSAKOI Sōran dance", rarity: 'common' },
    { id: "cornFox", label: "Corn fox", rarity: 'rare' },
    { id: "float", label: "Festival float", rarity: 'rare' },
    { id: "fireworks", label: "Fireworks over Odori", rarity: 'legendary' },
  ],
  "seoul": [
    { id: "guard", label: "Guard change", rarity: 'common' },
    { id: "hanbok", label: "Hanbok photo", rarity: 'common' },
    { id: "bindae", label: "Bindaetteok griddle", rarity: 'common' },
    { id: "stones", label: "Stepping stones", rarity: 'common' },
    { id: "quiet", label: "Bukchon quiet", rarity: 'common' },
    { id: "magpie", label: "Magpie thief", rarity: 'common' },
    { id: "snack", label: "Snack cart", rarity: 'common' },
    { id: "baedal", label: "Delivery scooter", rarity: 'common' },
    { id: "samulnori", label: "Samulnori", rarity: 'common' },
    { id: "jangma", label: "Monsoon umbrella", rarity: 'common' },
    { id: "snowball", label: "Snowball fight", rarity: 'common' },
    { id: "lanterns", label: "Lantern festival", rarity: 'common' },
    { id: "heron", label: "Grey heron", rarity: 'rare' },
    { id: "squirrel", label: "Pine squirrel", rarity: 'rare' },
    { id: "haechi", label: "Haechi wakes", rarity: 'legendary' },
  ],
  "shirakawago": [
    { id: "cannon", label: "Fire drill", rarity: 'common' },
    { id: "avalanche", label: "Roof snow slide", rarity: 'common' },
    { id: "karakuri", label: "Karakuri puppet", rarity: 'common' },
    { id: "yui", label: "Yui roof team", rarity: 'common' },
    { id: "sarubobo", label: "Giant sarubobo", rarity: 'common' },
    { id: "lightup", label: "Winter light-up", rarity: 'common' },
    { id: "kamoshika", label: "Japanese serow", rarity: 'rare' },
    { id: "hoba", label: "Hōba-miso grill", rarity: 'common' },
    { id: "shishimai", label: "Lion dance", rarity: 'common' },
    { id: "bus", label: "Nōhi bus", rarity: 'common' },
    { id: "kuma", label: "Black bear", rarity: 'rare' },
    { id: "fullmoon", label: "Full-moon village", rarity: 'legendary' },
  ],
  "tokyo": [
    { id: "scramble", label: "Scramble crossing", rarity: 'common' },
    { id: "oshiya", label: "Rush-hour pusher", rarity: 'common' },
    { id: "sumo", label: "Sumo stomp", rarity: 'common' },
    { id: "lantern", label: "Kaminarimon lantern", rarity: 'common' },
    { id: "vending", label: "Vending machine", rarity: 'common' },
    { id: "tower", label: "Tokyo Tower light show", rarity: 'common' },
    { id: "hachiko", label: "Hachikō comes alive", rarity: 'rare' },
    { id: "selfie", label: "Tower selfie", rarity: 'common' },
    { id: "ramen", label: "Ramen counter", rarity: 'common' },
    { id: "monja", label: "Monja on the teppan", rarity: 'common' },
    { id: "crow", label: "Crow vs. bin net", rarity: 'rare' },
    { id: "fireworks", label: "Sumida river fireworks", rarity: 'legendary' },
  ],
  "village": [
    { id: "keitora", label: "Kei truck", rarity: 'common' },
    { id: "chime", label: "Five o'clock chime", rarity: 'common' },
    { id: "kakashi", label: "Scarecrows", rarity: 'common' },
    { id: "paddy", label: "Duck patrol", rarity: 'common' },
    { id: "river", label: "Watermelon split", rarity: 'common' },
    { id: "ichiryo", label: "Cat stationmaster", rarity: 'common' },
    { id: "kappa", label: "Kappa", rarity: 'rare' },
    { id: "hotaru", label: "Fireflies", rarity: 'common' },
    { id: "dondo", label: "New Year bonfire", rarity: 'common' },
    { id: "kasajizo", label: "Kasa Jizō", rarity: 'legendary' },
  ],
}
